import React from 'react';
import './TextInput.css'; 

const TextInput = ({ input, setInput, handleSendMessage }) => {
  return (
    <form 
      onSubmit={handleSendMessage} 
      className="p-4  flex flex-col sm:flex-row items-center gap-y-2 sm:gap-y-0" 
    >
      <div className="form-control flex-grow w-full sm:w-auto">
        <input
          type="text"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          placeholder="Ask your Question"
          className="input input-alt w-full"
          required
        />
        <span className="input-border input-border-alt"></span>
      </div>
      <div className="px-2 w-full sm:w-auto">
        <button type="submit" className="button-64 w-full sm:w-auto" role="button">
          <span className="text">Ask</span>
        </button>
      </div>
    </form>
  );
};

export default TextInput;
